export default {"src":"/_next/static/media/punjab-de-sher.86e523d4.svg","height":130,"width":187,"blurWidth":0,"blurHeight":0};